// Protocol and channel rules ported from Android GridAdapter / EquipmentActivity.
export const text = value => value == null || value === 'null' ? '' : String(value)
export const angles = [10, 20, 30, 40, 45, 50, 60, 70, 80, 90]
const hex = value => Number(value).toString(16).toUpperCase().padStart(2, '0')
export const butterfly = item => ['09', '25'].includes(text(item.type)) && text(item.deviceName) !== '1800000464'
export const gatewayControl = item => butterfly(item) || ['24', '2B'].includes(text(item.type))
export const percentOpening = item => text(item.percentage) !== ''
export function channels(item) {
  const num = text(item.deviceName) === '1800055845' ? '17' : text(item.deviceNum)
  if (num === '15') return []
  if (['1', '11', '14'].includes(num)) return [1]
  if (['2', '13', '16'].includes(num)) return [2]
  if (['4', '12', '17'].includes(num)) return [1, 2]
  if (num === '18') return [1, 2, 3]
  if (text(item.type) === '23F') return [1, 2, 3, 4]
  if (butterfly(item)) return [1]
  if (['01', '23', '23D', '24'].includes(text(item.type)) && !(text(item.type) === '23' && (!text(item.status1) || !text(item.status2)))) return [1, 2]
  return [1, 2, 3, 4].filter(n => text(item['status' + n]) && text(item['status' + n]) !== '0')
}
export function channelName(item, n) {
  const names = text(item.type) === '23F' ? ['A1', 'B1', 'A2', 'B2'] : ['23', '23D', '24'].includes(text(item.type)) ? ['A', 'B', 'C', 'D'] : ['1', '2', '3', '4']
  return '阀' + names[n - 1]
}
// Native single ordinary valve: switch state and water-flow contact use distinct bits.
export function singleValveBits(item, n) {
  const raw = text(item['status' + n])
  if (!raw || butterfly(item) || channels(item).length !== 1) return null
  const type = text(item.type)
  const modern = ['01', '23', '23D', '24'].includes(type) && text(item.deviceName) !== '1800000464'
  const special = text(item.deviceName) === '1800000464'
  const pairedProtocol = special || (modern && !(type === '23' && (!text(item.status1) || !text(item.status2))))
  const openBit = raw.length === 4 ? raw[pairedProtocol || modern ? 3 : 1] : pairedProtocol ? raw.slice(-1) : raw[0]
  const flowBit = raw.length === 4 ? raw[pairedProtocol ? 1 : 3] : pairedProtocol ? '0' : raw.slice(-1)
  return { open: openBit !== '0', flow: flowBit !== '0', showFlow: type !== '23' }
}
export function valveState(item, n) {
  const raw = text(item['status' + n])
  if (!raw) return { label: '未上报', open: false, abnormal: false }
  if (butterfly(item)) {
    const value = Number(raw)
    return { label: !Number.isFinite(value) || value > 105 ? '阀门异常' : value > 5 ? `已开 ${value}%` : '已关', open: value > 5 && value <= 105, abnormal: !Number.isFinite(value) || value > 105 }
  }
  const last = raw.slice(-1).toUpperCase()
  const abnormal = ['F', 'E'].includes(last) || raw === '255'
  const modern = ['01', '23', '23D', '23F', '24', '2C'].includes(text(item.type)) && text(item.deviceName) !== '1800000464'
  const bit = modern ? last : raw.length === 4 ? raw[1] : raw[0]
  const single = singleValveBits(item, n)
  const open = single ? single.open : bit !== '0'
  const degree = last === '1' ? 90 : last === '2' ? 45 : last === 'A' ? 80 : /^[3-9]$/.test(last) ? (Number(last) - 2) * 10 : null
  return { label: open ? `已开${degree && modern ? ' ' + degree + '°' : ''}` : '已关', open, abnormal: false, fault: abnormal }
}
export function openingCode(value) {
  if (!value || value === 90) return '1'
  if (value === 45) return '2'
  const code = Math.floor(value / 10) + 2
  return code < 3 || code > 10 ? '1' : code.toString(16).toUpperCase()
}
export function command(item, n, open, opening) {
  if (!Number.isInteger(n) || n < 1 || n > 4) throw new Error('阀门通道无效')
  const value = opening == null ? Number(item.opening) || (percentOpening(item) ? 100 : 90) : Number(opening)
  if (open && (!Number.isFinite(value) || value < 1 || value > 100)) throw new Error('开度无效')
  if (butterfly(item)) {
    if (n > 3 || (open && opening != null && value < 5)) throw new Error('蝶阀开度应为5–100%')
    return '8A18' + hex(n - 1) + '02' + hex(open ? opening == null ? 100 : value : 0)
  }
  let protocol = '0'
  ;[1, 2, 3, 4].forEach(index => {
    const status = text(item['status' + index])
    if (status) protocol = status.length === 4 && status[0] !== '0' ? '2' : '0'
  })
  if (['23', '23D', '23F', '24'].includes(text(item.type))) protocol = '2'
  // Independent two-way angle valves use A610 regardless of ctrlType.
  if (text(item.deviceNum) === '3' || text(item.type) === '2C') return 'A610' + hex(n - 1) + '2' + (open ? openingCode(value) : '0')
  if (text(item.ctrlType) === '1' || channels(item).length === 4) {
    if (open && percentOpening(item) && value !== 100) return 'A618' + hex(n - 1) + protocol + 'B' + hex(value)
    return 'A610' + hex(n - 1) + protocol + (open ? openingCode(value) : '0')
  }
  if (n > 2) throw new Error('设备协议不支持该通道')
  return (n === 1 ? '8208' : '8308') + protocol + (open ? openingCode(value) : '0')
}
export function controlWait(item, now = Date.now()) {
  const timeout = text(item.deviceName) === '1800000464' ? 120 : item.type === '09' ? 65 : item.type === '25' ? text(item.subtype) === '3' ? 310 : 120 : ['01', '23', '23D', '24', '2C'].includes(item.type) ? 120 : 60
  return Math.max(0, ...[1, 2, 3, 4].map(n => {
    if (text(item['ctrlStatus' + n]) !== '1') return 0
    const date = Date.parse(text(item['ctrlTime' + n]).replace(/-/g, '/'))
    return Number.isFinite(date) ? Math.max(0, Math.ceil(timeout - (now - date) / 1000)) : timeout
  }))
}
export function connection(item, admin) {
  if (!text(item.deviceName)) return '未绑定'
  if (text(item.status) !== '1') return text(item.status) === '2' ? '无网关' : '离线'
  const standard = ['1A', '03', '04', '05', '0A', '0B', '11', '13', '14', '15', '17', '1E', '26', '23D']
  const threshold = item.type === '01' ? 7200 : ['23', '24'].includes(item.type) ? admin ? 3600 : 3400 : standard.includes(item.type) ? 2800 : 0
  if (threshold && (!text(item.voltage) || item.voltage === '无')) return '异常'
  if (threshold && Number(item.voltage) <= threshold) return '低电'
  return channels(item).some(n => valveState(item, n).abnormal) ? '异常' : '在线'
}
export function bindParameters(deviceName, selected, adjustable, gw, cdzId) {
  let num = selected.length === 2 ? 0 : selected[0] || 0
  const prefix = deviceName.slice(0, 2)
  if (prefix === '42') num = adjustable ? ({ 0: 17, 1: 14, 2: 13 })[num] : ({ 0: 12, 1: 11, 2: 16 })[num]
  const data = { cdzId, deviceName, num }
  if (prefix === '18' && gw) return { endpoint: 'setDevice', data: { ...data, gw } }
  if (['18', '98', '42'].includes(prefix)) return { endpoint: 'bindDevice', data }
  return { endpoint: 'bindGWDevice', data: { cdzId, deviceName } }
}
export function distance(a, b) {
  const parse = value => text(value).split(',').map(Number)
  const p = parse(a), q = parse(b)
  if (p.length !== 2 || q.length !== 2 || ![...p, ...q].every(Number.isFinite)) return Infinity
  const rad = x => x * Math.PI / 180
  const h = Math.sin(rad(q[1] - p[1]) / 2) ** 2 + Math.cos(rad(p[1])) * Math.cos(rad(q[1])) * Math.sin(rad(q[0] - p[0]) / 2) ** 2
  return 6371 * 2 * Math.asin(Math.min(1, Math.sqrt(h)))
}
// Same GB2312 initial ranges as Android ChineseCharacterHelper, no dependency.
let initials
export function projectCode(name) {
  if (!initials) {
    initials = {}
    const decoder = new TextDecoder('gbk')
    const ranges = [1601, 1637, 1833, 2078, 2274, 2302, 2433, 2594, 2787, 3106, 3212, 3472, 3635, 3722, 3730, 3858, 4027, 4086, 4390, 4558, 4684, 4925, 5249, 5600]
    for (let i = 0; i < 23; i++) for (let code = ranges[i]; code < ranges[i + 1]; code++) {
      if (code % 100 >= 1 && code % 100 <= 94) initials[decoder.decode(new Uint8Array([Math.floor(code / 100) + 160, code % 100 + 160]))] = 'ABCDEFGHJKLMNOPQRSTWXYZ'[i]
    }
  }
  return Array.from(name).map(c => c.charCodeAt(0) < 128 ? c : initials[c] || '#').join('')
}
